import { X } from "react-feather";
import React from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import TextInput from "../Formik/TextInput";
import DropdownSelect from "../Formik/DropdownSelect";
import SingleChoiceInput from "../Formik/SingleChoiceInput";

export const ModalAddEditProductSpecificQuestion = ({item = null, products = [], onHandleToggle, handleAction, title, message, errorMessage = ''}) => {
    const isEdit = Boolean(item);

    const formik = useFormik({
        initialValues: {
            product: isEdit ? products.find(product => product.id === item.product_id) : null,
            question: item ? item.question : '',
            question_short: item ? item.question_short : '',
            hover_text: item ? item.hover_text : '',
            appearance: item ? item.appearance : true,
        },
        validationSchema: Yup.object({
            product: Yup.object().required("Product is required."),
            question: Yup.string().trim().max(255, "Question cannot exceed 255 characters.").required("Question is required."),
            question_short: Yup.string().trim().max(60, "Question short cannot exceed 60 characters.").required("Question short is required."),
            hover_text: Yup.string().trim().max(1500, "Hover text cannot exceed 1500 characters.").nullable().notRequired(),
            appearance: Yup.bool(),
        }),
        onSubmit: (values) => {
            handleAction({
                id: item?.id,
                productId: values.product?.id,
                question: values.question,
                questionShort: values.question_short,
                hoverText: values.hover_text,
                appearance: values.appearance,
            });
        }
    });

    const selectProduct = (item) => {
        formik.setFieldValue('product', item);
    };

    return (
        <div>
            <div className="sl-modal-header sl-rounded-md sl-flex sl-justify-between sl-bg-gray-50 sl-text-gray-900 sl-px-6 sl-py-16 sl-border-bottom">
                <div id="message-modal-title" className="title sl-font-semibold sl-text-lg sl-mr-auto sl-ml-0">
                    {title}
                </div>
                <div className="sl-cursor-pointer sl-btn-link-gray sl-mr-0" onClick={onHandleToggle}>
                    <X/>
                </div>
            </div>
            <div className="sl-modal-body">
                <div className="sl-px-6 sl-pb-0 sl-pt-24">
                    <div className="sl-text-md sl-font-normal sl-text-gray-700">
                        {message}
                    </div>
                    <div className={'sl-mt-4 sl-flex sl-flex-col sl-gap-6'}>

                        {!isEdit && <DropdownSelect
                            formik={formik}
                            label={'Product'}
                            name={'product'}
                            selectedItem={formik.values.product}
                            fieldDefaultText={'Select product'}
                            options={products}
                            onChange={selectProduct}
                            elementClasses={'sl-mt-2'}
                        >
                        </DropdownSelect>}

                        <TextInput formik={formik} label={'Question'} name={'question'}/>
                        <TextInput formik={formik} label={'Question short'} name={'question_short'}/>
                        <TextInput formik={formik} label={'Hover text'} name={'hover_text'}/>
                        <SingleChoiceInput
                            formik={formik}
                            label={'Appearance'}
                            name={'appearance'}
                            options={[
                                {value: true, label: 'Visible'},
                                {value: false, label: 'Hidden'},
                            ]}
                            onChange={(e) => formik.setFieldValue('appearance', e.target.value === 'true')}
                        />

                        <div className="sl-text-error-500 sl-font sl-text-sm sl-font">
                            {errorMessage}
                        </div>
                    </div>
                </div>
            </div>
            <div className="sl-modal-footer sl-px-6 sl-py-32">
                <div
                    className="sl-flex sl-justify-end sl-gap-2-point-5 sl-bg-white sl-rounded-bottom-left-xl sl-rounded-bottom-right-xl sl-mt-0i sl-font sl-text-md sl-font-normal">
                    <button onClick={onHandleToggle}
                            className="sl-btn sl-btn-tertiary sl-btn-lg sl-rounded-lg ">
                        Cancel
                    </button>
                    <button onClick={formik.submitForm}
                            className="sl-btn sl-btn-primary sl-btn-lg sl-rounded-lg ">
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};
export default ModalAddEditProductSpecificQuestion;